module.exports = __webpack_public_path__ + "static/media/uneeq_logo.c2d70761.jpg";